import { __callbacks } from "Utils/Callbacks/Callback";
import { AppContext } from "Utils/Contexts";
import { AppState, ChatState } from "Utils/Enums";
import { __utils } from "Utils/Utils";
import { useContext, useEffect, useRef, useState } from "react";
import styles from "./Body.module.scss";
import Continue from "./components/Continue/Continue";
import New from "./components/New/New";
import Loading from "components/Loading/Loading";

export default function Body() {

    const appStateContext = useContext(AppContext);
    const [key, setKey] = useState(__utils.getUuidv4());
    const [chatState, setChatState] = useState<ChatState | null>(null);
    const [conversationId, setConversationId] = useState<string | undefined>(undefined);
    const [classHide, setClassHide] = useState<string>(styles["hide"]);

    const container = useRef<any>(null);

    useEffect(() => {
        __callbacks.onStartNewChat((data: any) => {
            setChatState(null);
            setClassHide("");

            setTimeout(() => {
                setClassHide(styles["hide"]);
                setChatState(ChatState.newConversation);
                setKey(__utils.getRandomIdShort());
                __callbacks.enableChatInputs.trigger({});
            }, 1000);
        });

        __callbacks.onContinueConversation((data: any) => {

            if (data.conversationId) {
                setConversationId(data.conversationId);
            } else {
                //console.error("Missing conversationId in data:", data);
                setConversationId("defaultConversationId");
            }

            setChatState(null);
            setClassHide("");

            __callbacks.setChatHeaderSmall.trigger({ data: "set chat header to small" });

            setTimeout(() => {
                setKey(__utils.getRandomIdShort());
                setChatState(ChatState.continueConversation);
            }, 1000);

            setTimeout(() => {
                setClassHide(styles["hide"]);
            }, 2000);
        });
    }, []);

    useEffect(() => {
        if (appStateContext === AppState.home) {
            setChatState(null);
        }
    }, [appStateContext]);

    useEffect(() => {
        __callbacks.onScrollToBottomChat((data: any) => {
            setTimeout(() => {
                container.current.scrollTop = container.current.scrollHeight;
            }, data.delay);
        });

        __callbacks.onScrollChatBottom((behavior: string) => {
            container.current.scrollTo({
                top: container.current.scrollHeight,
                behavior
            });
        });

    }, [container]);

    return (
        <div className={styles["container-wrapper"]}>
            <div className={`${styles.loading} ${classHide}`}><Loading></Loading></div>
            <div ref={container} className={`${styles.container}`}>
                {(chatState === ChatState.newConversation) ?
                    (
                        <New></New>
                    ) :
                    (
                        (chatState === ChatState.continueConversation && conversationId) ?
                            (
                                <Continue key={key} chatId={conversationId}></Continue>
                            ) :
                            (
                                <></>
                            )
                    )}
            </div>
        </div>
    )
}
